import React from 'react';
import { inject, observer } from 'mobx-react';
import {injectStripe, CardElement} from 'react-stripe-elements';
import { withRouter } from 'react-router-dom';
import HttpClient from 'services/HttpClient';

const CHARGE_CREATE = '/api/v1/charges/create';

@withRouter
@inject('alert')
@inject('purchased')
@inject('workshopDetails')
@observer
class CheckoutForm extends React.Component {
  constructor() {
    super();
    this.state = {
      isValidCardInfo: false,
      elementFontSize: window.innerWidth < 450 ? '10px' : '16px',
      disabled: false,
    };
  }

  completeOrder = (clientSecret) => {
    const {stripe} = this.props;
    stripe.retrievePaymentIntent(clientSecret)
    .then(result => {
      // const paymentIntent = result.paymentIntent;
      console.log(result)
      setTimeout(() => {
        this.setState({disabled: false});
        this.props.hideStripeModal();
        this.props.purchased.onPurchaseCompleted();
        this.props.workshopDetails.workshop.fee && this.props.purchased.setRedirectedToPurchase();
        this.props.alert.success('Your payment has been successful. Please refresh the page')
        if (window.location.pathname.includes('iacp')) {
          this.props.history.push('/iacp/purchased');
        } else if (window.location.pathname.includes('aci')) {
          this.props.history.push('/aci/purchased');
        } else {
          this.props.history.push('/purchased');
        }
      }, 3000);
    });
  }

  handleSubmit = async (ev) => {
    ev.preventDefault();
    const {stripe, elements, onToken} = this.props;
    try {
      if (!stripe || !elements) {
        return;
      }
      this.setState({disabled: true});
      const payload = await stripe.createPaymentMethod({
        type: "card",
        card: elements.getElement('card'),
      });
      const payment_method = payload.paymentMethod.id;
      const code = localStorage.getItem('@coupon');
      const params = { token: payment_method, workshop_id: this.props.workshopDetails.workshop.id, code };
      this.props.alert.info('The page will refresh with a successful purchase in a few moments.');
      const data = await new HttpClient().post(CHARGE_CREATE, params)
      if(data.body.payment_intent_client_secret) {
        this.props.hideStripeModal();
        localStorage.removeItem('@coupon');
        stripe.confirmCardPayment(data.body.payment_intent_client_secret, {
          payment_method: {
            card: elements.getElement('card')
          }
        })
        .then(result => {
          if(result.error) {
            this.props.alert.error(result.error.message || 'We are sorry but something went wrong');
            console.log(result.error)
            this.props.hideStripeModal();
          } else {
            this.completeOrder(
              data.body.payment_intent_client_secret,
            );
          }
        });
      } else {
        this.props.alert.error(data.body ? (data.body.message || 'We are sorry but something went wrong') : 'We are sorry but something went wrong');
        this.props.hideStripeModal();
      }
    } catch (e) {
      console.log(e);
      if(e.response) {
        if(e.response.status === 409) {
          const client_secret = e.response.data.payment.client_secret;
          stripe.confirmCardPayment(client_secret, {
            payment_method: {
              card: elements.getElement('card')
            }
          })
          .then(result => {
            if(result.error) {
              this.props.alert.error(result.error.message || 'We are sorry but something went wrong');
              console.log(result.error)
            } else this.completeOrder(client_secret);
          });
        } else {
          this.props.hideStripeModal();
          this.props.alert.error(e.body.message || 'We are sorry but something went wrong');
        }
      } else {
        this.props.hideStripeModal();
        this.props.alert.error(e.message || (e.body && e.body.message) || 'We are sorry but something went wrong');
      }
    }
  };

  decline = () => {
    this.props.hideStripeModal();
  };

  onChange = event => {
    const {isValidCardInfo} = this.state;
    if(event.complete) {
      this.setState({isValidCardInfo: true});
    } else if(isValidCardInfo && !event.complete) {
      this.setState({isValidCardInfo: false});
    }
  }

  createOptions = (fontSize, padding) => {
    return {
      style: {
        base: {
          fontSize,
          color: '#424770',
          letterSpacing: '0.025em',
          fontFamily: 'Source Code Pro, monospace',
          '::placeholder': {
            color: '#aab7c4',
          },
          padding,
        },
        invalid: {
          color: '#9e2146',
        },
      },
    };
  };

  render() {
    const {cost} = this.props;
    const {isValidCardInfo, elementFontSize, disabled} = this.state;
    return (
      <form onSubmit={this.handleSubmit} className="stripe-form">
        <div className="stripe-card-wrapper">
          <CardElement
            hidePostalCode
            onChange={this.onChange}
            style={{
              base: {
                color: "#32325D",
                fontFamily: "Inter UI, Open Sans, Segoe UI, sans-serif",
                fontSize: elementFontSize,
        
                "::placeholder": {
                  color: "#919199"
                }
              },
              invalid: {
                color: "#E25958"
              }
            }}
          />
        </div>
        <div className="stripe-buttons">
          <div
            onClick={this.decline}
            className="workshop-creator-sidebar-publish stripe-decline-btn"
          >
            <span className="btn bordered white" style={{ padding: 15 }}>Decline</span>
          </div>
          <button
            onClick={this.handleSubmit}
            className="workshop-creator-sidebar-publish"
            disabled={!isValidCardInfo || disabled}
            style={{
              border: 0,
              backgroundColor: 'white',
            }}
          >
            <span className="btn prime bordered" style={{ padding: 15, opacity: isValidCardInfo && !disabled ? 1 : 0.5 }}>Submit payment {` ${cost ? Number(cost / 100).toFixed(2) : ''} €`}</span>
          </button>
        </div>
        {/* <button className="btn" onClick={this.handleSubmit}>
          Submit payment {` ${cost ? Number(cost / 100).toFixed(2) : ''} €`}
        </button> */}
      </form>
    );
  }
}

export default injectStripe(CheckoutForm);


// WEBPACK FOOTER //
// ./src/components/providers/online_workshop_details/CheckoutForm.jsx